import React from 'react';

const ModalMenuSecondary = () => {
    return (
        <nav className="menu-secondary">
            <ul className="nav">
                <li className="nav-item">
                    <a title="Villkor" href={ process.env.PUBLIC_URL + "/terms" }>Villkor</a>
                </li>
            </ul>
        </nav>
    );
};

export default ModalMenuSecondary;
